export default "__VITE_ASSET__03080e33__"